import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  Table,
  Button,
  Sheet,
  Modal,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Select,
  Option,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, PageTitle } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { STATUS } from "../../../constant";
import { connect, useDispatch } from "react-redux";
import { useMediaQuery } from "@mui/material";
import {
  deactivateAgentStaffRequest,
  activateAgentStaffRequest,
  deactivateAgentStaffReset,
  activateAgentStaffReset,
  viewAgentStaffReset,
  viewAgentStaffRequest,
  rejectAgentStaffRequest,
  rejectAgentStaffReset,
  approveAgentStaffRequest,
  approveAgentStaffReset,
  editAgentStaffRequest,
  editAgentStaffReset,
  unblockAgentRequest,
  unblockAgentReset,
  resetAgentPasswordRequest,
  resetAgentPasswordReset,
} from "../../../store/actions";
import {
  BlockOutlined,
  CheckCircle,
  DoNotDisturbOn,
  EditOutlined,
  LockOpenOutlined,
  TaskAltOutlined,
} from "@mui/icons-material";
import AccountCard from "./AccountCard";

function CreateItems(title: String, value: String) {
  return { title, value };
}

const AgentStaffViewPage = ({
  loginResult,

  editAgentStaffStatus,
  editAgentStaffResult,
  editAgentStaffErrorMessage,

  viewAgentStaffStatus,
  viewAgentStaffResult,
  viewAgentStaffErrorMessage,

  rejectAgentStaffStatus,
  rejectAgentStaffResult,
  rejectAgentStaffErrorMessage,

  approveAgentStaffStatus,
  approveAgentStaffResult,
  approveAgentStaffErrorMessage,

  activateAgentStaffStatus,
  activateAgentStaffResult,
  activateAgentStaffErrorMessage,

  deactivateAgentStaffStatus,
  deactivateAgentStaffResult,
  deactivateAgentStaffErrorMessage,

  resetAgentPasswordStatus,
  resetAgentPasswordResult,
  resetAgentPasswordErrorMessage,

  unblockAgentStatus,
  unblockAgentResult,
  unblockAgentErrorMessage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { agentStaff_id } = state;
  const isDesktop = useMediaQuery("(min-width:600px)");

  const [formModal, setFormModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);

  const [fname, setFName] = useState("");
  const [sname, setSName] = useState("");
  const [lname, setLName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState(0);

  useEffect(() => {
    if (viewAgentStaffStatus === STATUS.SUCCESS) {
      setFName(viewAgentStaffResult.first_name);
      setSName(viewAgentStaffResult.middle_name);
      setLName(viewAgentStaffResult.last_name);
      setEmail(viewAgentStaffResult.email);
      setMobile(viewAgentStaffResult.mobile_num);
      setRole(viewAgentStaffResult.role.toString());
      setStatus(viewAgentStaffResult.status);
      setRemark(viewAgentStaffResult.remark);
      setTimeout(() => {
        dispatch(viewAgentStaffReset());
      }, 2000);
    }

    if (editAgentStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff edited successful");
      setFormModal(false);
      dispatch(viewAgentStaffRequest(loginResult.token, { id: agentStaff_id }));
      dispatch(editAgentStaffReset());
    } else if (editAgentStaffStatus === STATUS.ERROR) {
      toast.error(editAgentStaffErrorMessage);
      dispatch(editAgentStaffReset());
    }

    if (approveAgentStaffStatus === STATUS.SUCCESS) {
      toast.success("AgentStaff approved successful");
      dispatch(viewAgentStaffRequest(loginResult.token, { id: agentStaff_id }));
      dispatch(approveAgentStaffReset());
    } else if (approveAgentStaffStatus === STATUS.ERROR) {
      toast.error(approveAgentStaffErrorMessage);
      dispatch(approveAgentStaffReset());
    }

    if (rejectAgentStaffStatus === STATUS.SUCCESS) {
      toast.success("AgentStaff rejected successful");
      setRejectModal(false);
      dispatch(viewAgentStaffRequest(loginResult.token, { id: agentStaff_id }));
      dispatch(rejectAgentStaffReset());
    } else if (rejectAgentStaffStatus === STATUS.ERROR) {
      toast.error(rejectAgentStaffErrorMessage);
      dispatch(rejectAgentStaffReset());
    }

    if (activateAgentStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff activated successful");
      dispatch(viewAgentStaffRequest(loginResult.token, { id: agentStaff_id }));
    } else if (activateAgentStaffStatus === STATUS.ERROR) {
      toast.error(activateAgentStaffErrorMessage);
      dispatch(activateAgentStaffReset());
    }

    if (deactivateAgentStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff deactivated successful");
      setDeactivateModal(false);
      dispatch(viewAgentStaffRequest(loginResult.token, { id: agentStaff_id }));
      dispatch(deactivateAgentStaffReset());
    } else if (activateAgentStaffStatus === STATUS.ERROR) {
      toast.error(deactivateAgentStaffErrorMessage);
      dispatch(deactivateAgentStaffReset());
    }

    if (resetAgentPasswordStatus === STATUS.SUCCESS) {
      toast.success("Agent user password reset successful");
      dispatch(viewAgentStaffRequest(loginResult.token, { id: agentStaff_id }));
      dispatch(resetAgentPasswordReset());
    } else if (resetAgentPasswordStatus === STATUS.ERROR) {
      toast.error(resetAgentPasswordErrorMessage);
      dispatch(resetAgentPasswordReset());
    }

    if (unblockAgentStatus === STATUS.SUCCESS) {
      toast.success("Agent user unblocked  successful");
      dispatch(viewAgentStaffRequest(loginResult.token, { id: agentStaff_id }));
      dispatch(unblockAgentReset());
    } else if (unblockAgentStatus === STATUS.ERROR) {
      toast.error(unblockAgentErrorMessage);
      dispatch(unblockAgentReset());
    }
  });

  useEffect(() => {
    if (agentStaff_id != "") {
      dispatch(viewAgentStaffRequest(loginResult.token, { id: agentStaff_id }));
    }
  }, []);

  const handleRoleSelection = (event, newValue) => {
    setRole(newValue);
  };

  const submitForm = (event) => {
    event.preventDefault();
    if (fname && sname && lname && email && mobile) {
      const data = {
        id: agentStaff_id,
        first_name: fname,
        middle_name: sname,
        last_name: lname,
        email: email,
        mobile_num: mobile,
        role: role,
      };
      dispatch(editAgentStaffRequest(loginResult.token, data));
    } else {
      toast.error("Please fill all required information");
    }
  };

  // ------ actions -------------------------
  const approveAgentStaff = () => {
    const data = {
      id: agentStaff_id,
    };
    dispatch(approveAgentStaffRequest(loginResult.token, data));
  };

  const rejectAgentStaff = (event) => {
    event.preventDefault();
    const data = {
      id: agentStaff_id,
      remark: remark,
    };
    dispatch(rejectAgentStaffRequest(loginResult.token, data));
  };

  const activateAgentStaff = () => {
    const data = {
      id: agentStaff_id,
    };
    dispatch(activateAgentStaffRequest(loginResult.token, data));
  };

  const deactivateAgentStaff = (event) => {
    event.preventDefault();
    const data = {
      id: agentStaff_id,
      remark: remark,
    };
    dispatch(deactivateAgentStaffRequest(loginResult.token, data));
  };

  const resetAgentPassword = () => {
    const data = {
      id: agentStaff_id,
    };
    dispatch(resetAgentPasswordRequest(loginResult.token, data));
  };

  const unblockAgent = () => {
    const data = {
      id: agentStaff_id,
    };
    dispatch(unblockAgentRequest(loginResult.token, data));
  };

  const checkLoading = () => {
    if (
      viewAgentStaffStatus === STATUS.LOADING ||
      editAgentStaffStatus === STATUS.LOADING ||
      approveAgentStaffStatus === STATUS.LOADING ||
      rejectAgentStaffStatus === STATUS.LOADING ||
      activateAgentStaffStatus === STATUS.LOADING ||
      deactivateAgentStaffStatus === STATUS.LOADING ||
      unblockAgentStatus === STATUS.LOADING ||
      resetAgentPasswordStatus === STATUS.LOADING
    ) {
      return true;
    } else {
      return false;
    }
  };

  const rows = [
    CreateItems("First Name", fname),
    CreateItems("Second Name", sname),
    CreateItems("Last Name", lname),
    CreateItems(
      "Role",
      {
        1: "Admin",
        2: "Manager",
        3: "Sale Officer",
        4: "Quality Assurance Personnel",
      }[role],
    ),
    CreateItems(
      "Status",
      { 1: "Active", 2: "Inactive", 3: "Locked", 4: "Rejected", 5: "Pending" }[
        status
      ],
    ),
    CreateItems("Email", email),
    CreateItems("Mobile", mobile),
    CreateItems("Remark", remark),
  ];

  return (
    <Box>
      <PageTitle title={`Agent staff ${fname} Details`} />

      <LoadingView loading={checkLoading()} />
      <AccountCard />

      {/* Contents */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {/* Action Button */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", md: "row" },
          }}
        ></Box>

        {/* Details */}
        <Box
          sx={{
            gap: 2,
            display: "flex",
            flexDirection: "column",
            width: { xs: "unset", md: "70%" },
          }}
        >
          {/* client details */}
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              // display: 'flex',
              // width: '100%',
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              // aria-label="striped table"
              // stripe="odd"
              // variant="soft"
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>
                    Agent Staff Details
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <b>{row.title}</b>
                    </td>
                    <td>{row.value}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Sheet>
        </Box>
      </Box>

      {/* ------ Modal form for add and edit agentAgentStaff details ------ */}
      <Modal open={formModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              top: "60px",
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose variant="outlined" onClick={() => setFormModal(false)} />
          <DialogTitle>{"Edit Agent Staff " + fname}</DialogTitle>
          <DialogContent>
            Please enter agentAgentStaff details correct.
          </DialogContent>
          <Stack component="form" onSubmit={submitForm} gap={2} sx={{ mt: 2 }}>
            <Stack direction={{ xs: "column", md: "row" }} gap={2}>
              {/* first name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>First Name</FormLabel>
                <Input
                  type="text"
                  value={fname}
                  onChange={(e) => setFName(e.target.value)}
                  placeholder="Enter your first name"
                />
              </FormControl>

              {/* second name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Middle Name</FormLabel>
                <Input
                  type="text"
                  value={sname}
                  onChange={(e) => setSName(e.target.value)}
                  placeholder="Enter your second name"
                />
              </FormControl>

              {/* last name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Last Name</FormLabel>
                <Input
                  type="text"
                  value={lname}
                  onChange={(e) => setLName(e.target.value)}
                  placeholder="Enter your third name"
                />
              </FormControl>
            </Stack>

            <Stack direction={{ xs: "column", md: "row" }} gap={2}>
              {/* mobile number */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Mobile number</FormLabel>
                <Input
                  type="tel"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  placeholder="Enter agentAgentStaff phone number"
                />
              </FormControl>

              {/* email */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter agentAgentStaff email"
                />
              </FormControl>
            </Stack>

            <Stack direction={{ xs: "column", md: "row" }} gap={2}>
              {/* role */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Role</FormLabel>
                <Select
                  placeholder="Select agent ownership"
                  value={role}
                  onChange={handleRoleSelection}
                  required
                >
                  <Option value="1">Admin</Option>
                  <Option value="2">Manager</Option>
                  <Option value="3">Sales Officer</Option>
                  <Option value="4">Quality Assurance Personnel</Option>
                </Select>
              </FormControl>
            </Stack>

            <Stack gap={4} sx={{ mt: 2 }}>
              <Button type="submit" fullWidth>
                Submit
              </Button>
            </Stack>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* reject modal */}
      <Modal open={rejectModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setRejectModal(false)}
          />
          <DialogTitle>{"Reject agentAgentStaff:" + fname}</DialogTitle>
          <DialogContent>Please write a reason for rejection.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={rejectAgentStaff}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Rejection reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              REJECT
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* deactivate modal */}
      <Modal open={deactivateModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          // aria-labelledby="modal-dialog-overflow"
          // layout="fullscreen"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setDeactivateModal(false)}
          />
          <DialogTitle>{"Deactivate Agent Staff:" + fname}</DialogTitle>
          <DialogContent>Please write a reason for deactivation.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={deactivateAgentStaff}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Deactivate reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              DEACTIVATE
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>
    </Box>
  );
};

const mapStateToProps = ({ agentStaff, auth }) => {
  const { otpResult: loginResult } = auth;
  const {
    editAgentStaffStatus,
    editAgentStaffResult,
    editAgentStaffErrorMessage,

    viewAgentStaffStatus,
    viewAgentStaffResult,
    viewAgentStaffErrorMessage,

    rejectAgentStaffStatus,
    rejectAgentStaffResult,
    rejectAgentStaffErrorMessage,

    approveAgentStaffStatus,
    approveAgentStaffResult,
    approveAgentStaffErrorMessage,

    activateAgentStaffStatus,
    activateAgentStaffResult,
    activateAgentStaffErrorMessage,

    deactivateAgentStaffStatus,
    deactivateAgentStaffResult,
    deactivateAgentStaffErrorMessage,

    resetAgentPasswordStatus,
    resetAgentPasswordResult,
    resetAgentPasswordErrorMessage,

    unblockAgentStatus,
    unblockAgentResult,
    unblockAgentErrorMessage,
  } = agentStaff;

  return {
    loginResult,

    editAgentStaffStatus,
    editAgentStaffResult,
    editAgentStaffErrorMessage,

    viewAgentStaffStatus,
    viewAgentStaffResult,
    viewAgentStaffErrorMessage,

    rejectAgentStaffStatus,
    rejectAgentStaffResult,
    rejectAgentStaffErrorMessage,

    approveAgentStaffStatus,
    approveAgentStaffResult,
    approveAgentStaffErrorMessage,

    activateAgentStaffStatus,
    activateAgentStaffResult,
    activateAgentStaffErrorMessage,

    deactivateAgentStaffStatus,
    deactivateAgentStaffResult,
    deactivateAgentStaffErrorMessage,

    resetAgentPasswordStatus,
    resetAgentPasswordResult,
    resetAgentPasswordErrorMessage,

    unblockAgentStatus,
    unblockAgentResult,
    unblockAgentErrorMessage,
  };
};

export default connect(mapStateToProps, {})(AgentStaffViewPage);
